import { AdminDashboardDataFilter, AdminDashboardEarningsStatsResponse } from '../../graphql/API';
import { adminGetDashboardTotalEarningsData } from '../../graphql/queries';
import { executeGql, processGqlResult } from '../../utils/gql-utils';

export const adminGetDashboardTotalEarningsDataApi = async (
  filter: AdminDashboardDataFilter,
): Promise<AdminDashboardEarningsStatsResponse> => {
  const result = await executeGql(adminGetDashboardTotalEarningsData, { filter });
  return processGqlResult<AdminDashboardEarningsStatsResponse>(
    'adminGetDashboardTotalEarningsData',
    result,
  );
};
